import { forwardRef } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

/**
 * Voir : https://s-yadav.github.io/react-number-format/docs/customization#iban-account-input-field-with-pattern
 */
export const DateTimeInput = forwardRef<PatternFormatProps>((props, ref) => {
    return <PatternFormat {...props} format="##/##/#### ##:##" mask="_" placeholder="JJ/MM/AAAA HH:MM" getInputRef={ref} />;
});
